import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Validate driver email
 *
 * @private
 */
export const isDriverEmailAvailable = createAsyncThunk<
  // Return type of the payload creator
  'available' | 'invalid' | 'inUse',
  // First argument to the payload creator
  string,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driver/isDriverEmailAvailable', async (email, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/driver/isDriverEmailAvailable', {
      category: 'rpc',
      type: 'rpc/driver/isDriverEmailAvailable',
      email,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.available
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {validateDriverEmail}`,
      { tags: ['rpc', 'driver'], info: email },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Validate driver email: ${email}`,
      error,
    })
  }
})
